<template>
    <div v-if="isLoggedIn && appParams && appParams.staticTranslations">
        <div v-show="messageDialog ||
            deleteConfirmation ||
            deleteNoteConfirmation ||
            deleteCartConfirmation
            " class="itb-overlay"></div>
        <TermsAndCondition :visible="messageDialog" @close="messageDialog = false" />
        <DeleteDialog :visible="deleteConfirmation" @confirm="deleteGraphic" @cancel="cancelDeletion" />
        <DeleteNoteDialog :visible="deleteNoteConfirmation" @confirm="deleteProductNote" @cancel="cancelNoteDeletion" />
        <DeleteCartDialog :visible="deleteCartConfirmation" @confirm="deleteCart" @cancel="cancelCartDeletion" />

        <div class="itb-saved-carts container">
            <span class="itb-saved-carts-back"></span>

            <router-link :to="'/choose-the-graphic/2D'">
                {{ appParams.staticTranslations["carts.continue_shopping"] }}
            </router-link>
            <div v-if="message" class="container">
                <div class="row">
                    <div
                        class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center">
                        <div :class="'alert itb-alert alert-' + message.type" role="alert">
                            {{ message.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="itb-cart-page" v-if="showGraphicList">
            <div class="d-flex flex-column align-items-center">
                <div class="d-flex align-items-center">
                    <h2 class="itb-cart-title m-0 p-1">
                        {{ appParams.staticTranslations["carts.cart"] }}
                        {{ cartId }}
                    </h2>
                    <button type="button" class="btn btn-outline-primary" @click="saveCart" :disabled="isSaveDisabled">
                        {{ appParams.staticTranslations["carts.save_cart"] }}
                    </button>
                    <button type="button" class="btn btn-outline-primary itb-note-delete-button"
                        @click="confirmCartDeletion" :disabled="isSaveDisabled">
                        {{ appParams.staticTranslations["carts.clear_cart"] }}
                    </button>
                </div>
                <p class="itb-cart-subtitle mb-4">
                    {{
                        appParams.staticTranslations[
                        "carts.delivery_time_confirmation"
                        ]
                    }}
                </p>
            </div>
            <div class="container">
                <table class="table itb-cart-graphics-list">
                    <thead>
                        <tr class="itb-table-header">
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.items"]
                                }}
                            </th>
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.weight"]
                                }}
                            </th>
                            <th scope="col">
                                {{ appParams.staticTranslations["carts.pcs"] }}
                            </th>
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.price"]
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(graphic, index) in graphics" class="itb-product-fields">
                        <tr>
                            <td style="width: 340px">
                                <div class="row">
                                    <div class="col-2">
                                        <img v-if="graphic.image" class="itb-cart-img" v-bind:src="'/uploads/' +
                                            graphic.image.path +
                                            '/' +
                                            graphic.image.name
                                            " v-bind:alt="graphic.name" />
                                    </div>
                                    <div class="col-10">
                                        <div class="itb-cart-table-name">
                                            <a :href="graphic.url" target="_blank">
                                                {{ graphic.name_variant }}
                                            </a>
                                        </div>
                                        <div class="itb-cart-table-code">
                                            {{
                                                appParams.staticTranslations[
                                                "carts.code_label"
                                                ]
                                            }}:
                                            {{ graphic.graphic_code }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="itb-cart-table-weight">
                                {{ graphic.weight }} kg
                            </td>
                            <td class="itb-cart-table-quantity">
                                <div class="form-group d-inline-block mb-0">
                                    <div class="itb-input-quantity-wrapper">
                                        <input type="number" name="quantity" class="form-control itb-graphic-quantity"
                                            min="1" max="100" oninput="validity.valid||(value='');"
                                            @change="changeQuantity(index)" v-model="graphic.quantity" />
                                        <span class="itb-plus-sign" @click="increaseQuantity(index)">
                                            +
                                        </span>
                                        <span class="itb-minus-sign" @click="decreaseQuantity(index)">
                                            -
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td class="itb-cart-table-price">
                                {{ graphic.price }}
                            </td>
                            <td class="text-right">
                                <img src="/images/cancel.png" alt="delete" class="itb-delete-cart-item"
                                    @click="confirmDeletion(index)" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" class="pt-0 pl-0 pr-0 border-top-0">
                                <div class="itb-product-note-wrapper">
                                    <div class="itb-product-note-box" v-show="isProductNoteOpened[index]">
                                        <button type="button" class="itb-mdi-logo" @click="closeProductNote(index)">
                                            <img src="/images/times-solid.svg" alt="close"
                                                class="itb-icon itb-paperplane" />
                                        </button>
                                        <textarea class="form-control" id="itb-cart-form-product-note" rows="3"
                                            :placeholder="appParams.staticTranslations[
                                                'carts.add_your_note'
                                            ]
                                                " v-model.trim="graphic.note" @input="verifyProductNote(index)" :class="{
                                                    'itb-field-error':
                                                        !isProductNoteValid[index],
                                                }" />
                                    </div>
                                    <p class="itb-error-message mb-0" v-if="!isProductNoteValid[index]"
                                        aria-live="assertive">
                                        {{
                                            appParams.staticTranslations[
                                            "carts.field_must_not_exceed_255_characters"
                                            ]
                                        }}
                                    </p>
                                    <p v-if="
                                        !isProductNoteOpened[index] &&
                                        graphic.note.length > 0
                                    " class="itb-product-note-text">
                                        <strong>{{
                                            appParams.staticTranslations[
                                            "carts.note"
                                            ]
                                        }}:</strong>&#32;{{ graphic.note }}
                                    </p>

                                    <button type="button" class="btn btn-outline-primary ml-0" v-if="
                                        graphic.note.length < 1 &&
                                        !isProductNoteOpened[index]
                                    " @click="editProductNote(index)">
                                        <span>{{
                                            appParams.staticTranslations[
                                            "carts.add_note"
                                            ]
                                        }}</span><img src="/images/plus-solid.svg" alt="add note"
                                            class="itb-note-action-icon" />
                                    </button>
                                    <button type="button" class="btn btn-outline-primary ml-0"
                                        v-if="isProductNoteOpened[index]" :disabled="!isProductNoteValid[index] ||
                                            graphic.note.length < 1
                                            " @click="saveProductNote(index)">
                                        <span>{{
                                            appParams.staticTranslations[
                                            "carts.save_note"
                                            ]
                                        }}</span><img src="/images/check-solid.svg" alt="save note"
                                            class="itb-note-action-icon" />
                                    </button>
                                    <button type="button" class="btn btn-outline-primary ml-0" v-if="
                                        graphic.note.length > 0 &&
                                        !isProductNoteOpened[index]
                                    " @click="editProductNote(index)">
                                        <span>{{
                                            appParams.staticTranslations[
                                            "carts.edit_note"
                                            ]
                                        }}</span><img src="/images/pen-to-square-solid.svg" alt="edit note"
                                            class="itb-note-action-icon" />
                                    </button>
                                    <button type="button" class="btn btn-outline-primary itb-note-delete-button" v-if="
                                        graphic.note.length > 0 &&
                                        !isProductNoteOpened[index]
                                    " @click="confirmNoteDeletion(index)">
                                        <span>{{
                                            appParams.staticTranslations[
                                            "carts.delete_note"
                                            ]
                                        }}</span><img src="/images/times-solid-red.svg" alt="delete note"
                                            class="itb-note-action-icon" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="itb-cart-table-summary reefs" v-if="bonusDiscount">
                            <td>
                                <p class="m-0">
                                    {{
                                        appParams.staticTranslations[
                                        "carts.bonus_discount"
                                        ] +
                                        " " +
                                        bonusDiscount +
                                        "%"
                                    }}
                                </p>
                                <p class="m-0 itb-discount-code">
                                    {{
                                        appParams.staticTranslations[
                                        "carts.discount_code"
                                        ] +
                                        ": " +
                                        bonusDiscountCode
                                    }}
                                </p>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                                {{ bonusDiscountAmountFormatted }}
                            </td>
                            <td></td>
                        </tr>
                        <tr class="itb-cart-table-bonus-discount" v-if="!!inAdvanceDiscount">
                            <td>
                                <p class="m-0">
                                    {{
                                        appParams.staticTranslations[
                                        "carts.in_advance_discount"
                                        ] +
                                        " " +
                                        inAdvanceDiscount +
                                        "%"
                                    }}
                                </p>
                                <p class="m-0 itb-discount-code">
                                    {{
                                        appParams.staticTranslations[
                                        "carts.discount_code"
                                        ] +
                                        ": " +
                                        inAdvanceDiscountCode
                                    }}
                                </p>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                                {{ inAdvanceDiscountAmountFormatted }}
                            </td>
                            <td></td>
                        </tr>
                        <tr class="itb-cart-table-bonus-discount">
                            <td>
                                {{
                                    appParams.staticTranslations["carts.total"]
                                }}
                            </td>
                            <td>{{ totalWeight }} kg</td>
                            <td style="padding-left: 2rem">
                                {{ totalQuantity }}
                            </td>
                            <td>{{ totalPriceWithDiscountFormatted }}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
                <div>
                    <div class="itb-form-fields-cart">
                        <div>
                            <form id="cartform" class="container" @submit.prevent="save">
                                <div class="row">
                                    <div class="col bill-col">
                                        <h3 id="itb-cart-bill-info">
                                            {{
                                                appParams.staticTranslations[
                                                "carts.billing_details"
                                                ]
                                            }}
                                        </h3>
                                        <div class="m-0 d-flex align-items-end position-relative">
                                            <p class="m-0">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.want_to_pay_in_advance"
                                                    ]
                                                }}
                                            </p>
                                            <div class="itb-inline-checkbox-wrapper align-self-start ml-2" :class="wantToPayInAdvance
                                                ? 'itb-active'
                                                : ''
                                                ">
                                                <label for="itb-cart-advance-discount"
                                                    class="itb-inline-checkbox-label ml-auto">
                                                    <input type="checkbox" id="itb-cart-advance-discount" @input="correctPriceWithAdvanceDiscount
                                                        " v-model="wantToPayInAdvance
                                                            " />
                                                    <span class="itb-checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <label for="itb-cart-form-vat" class="itb-cart-mt">{{
                                            appParams.staticTranslations[
                                            "clients.vat"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-vat" :placeholder="appParams.staticTranslations[
                                            'clients.vat_placeholder'
                                        ]
                                            " v-model.trim="vat" disabled />
                                        <label for="itb-cart-form-bill-name" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.bill_name.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.bill_name"
                                            ]
                                        }}
                                        </label>
                                        <input type="text" class="form-control" id="itb-cart-form-bill-name"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.bill_name_placeholder'
                                            ]
                                                " v-model.trim="bill_name" @input="$v.bill_name.$touch()" :class="{
                                                    'itb-field-error':
                                                        $v.bill_name.$error,
                                                }" ref="bill_name" disabled />
                                        <div v-if="$v.bill_name.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.bill_name.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>

                                        <label for="itb-cart-form-bill-company" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.bill_company.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.bill_company"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-bill-company"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.bill_company_placeholder'
                                            ]
                                                " v-model.trim="bill_company" @input="$v.bill_company.$touch()" :class="{
                                                    'itb-field-error':
                                                        $v.bill_company.$error,
                                                }" ref="bill_company" disabled />
                                        <div v-if="$v.bill_company.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.bill_company.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label for="itb-cart-form-bill-street" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.bill_street.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.bill_street"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-bill-street"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.bill_street_placeholder'
                                            ]
                                                " v-model.trim="bill_street" @input="$v.bill_street.$touch()" :class="{
                                                    'itb-field-error':
                                                        $v.bill_street.$error,
                                                }" ref="bill_street" disabled />
                                        <div v-if="$v.bill_street.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.bill_street.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <div class="row itb-city-postcode">
                                            <div class="col-lg-8">
                                                <label for="itb-cart-form-bill-city" class="itb-cart-mt" :class="{
                                                    'itb-label-error':
                                                        $v.bill_city.$error,
                                                }">{{
                                                    appParams
                                                        .staticTranslations[
                                                    "clients.bill_city"
                                                    ]
                                                }}</label>
                                                <input type="text" class="form-control" id="itb-cart-form-bill-city"
                                                    :placeholder="appParams
                                                        .staticTranslations[
                                                        'clients.bill_city_placeholder'
                                                    ]
                                                        " v-model.trim="bill_city" @input="
                                                            $v.bill_city.$touch()
                                                            " :class="{
                                                                'itb-field-error':
                                                                    $v.bill_city.$error,
                                                            }" ref="bill_city" disabled />
                                                <div v-if="$v.bill_city.$dirty">
                                                    <p class="itb-error-message mb-0" v-if="
                                                        !$v.bill_city
                                                            .required
                                                    " aria-live="assertive">
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                            "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <label for="itb-cart-form-bill-postcode" class="itb-cart-mt" :class="{
                                                    'itb-label-error':
                                                        $v.bill_postcode
                                                            .$error,
                                                }">{{
                                                    appParams
                                                        .staticTranslations[
                                                    "clients.bill_postcode"
                                                    ]
                                                }}</label>
                                                <input type="text" class="form-control" id="itb-cart-form-bill-postcode"
                                                    :placeholder="appParams
                                                        .staticTranslations[
                                                        'clients.bill_postcode_placeholder'
                                                    ]
                                                        " v-model.trim="bill_postcode" @input="
                                                            $v.bill_postcode.$touch()
                                                            " :class="{
                                                                'itb-field-error':
                                                                    $v.bill_postcode
                                                                        .$error,
                                                            }" ref="bill_postcode" disabled />
                                                <div v-if="
                                                    $v.bill_postcode.$dirty
                                                ">
                                                    <p class="itb-error-message mb-0" v-if="
                                                        !$v.bill_postcode
                                                            .required
                                                    " aria-live="assertive">
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                            "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <label for="itb-cart-form-bill-country" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.bill_country.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.bill_country"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-bill-country"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.bill_country_placeholder'
                                            ]
                                                " v-model.trim="bill_country_text" @input="$v.bill_country.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.bill_country.$error,
                                            }" ref="bill_country" disabled />
                                        <div v-if="$v.bill_country.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.bill_country.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label for="itb-cart-form-email" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.email.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.email"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-email" :placeholder="appParams.staticTranslations[
                                            'clients.email_placeholder'
                                        ]
                                            " v-model.trim="email" @input="$v.email.$touch()" :class="{
                                                'itb-field-error':
                                                    $v.email.$error,
                                            }" ref="email" disabled />
                                        <div v-if="$v.email.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.email.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                            <p class="itb-error-message mb-0" v-if="!$v.email.email"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.email_must_be_valid"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label for="itb-cart-form-phone" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.phone.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.phone"
                                            ]
                                        }}</label>
                                        <input type="tel" class="form-control" id="itb-cart-form-phone" :placeholder="appParams.staticTranslations[
                                            'clients.phone_placeholder'
                                        ]
                                            " v-model.trim="phone" @input="$v.phone.$touch()" :class="{
                                                'itb-field-error':
                                                    $v.phone.$error,
                                            }" ref="phone" disabled />
                                        <div v-if="$v.phone.$dirty">
                                            <p class="itb-error-message mb-0" v-if="!$v.phone.required"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                            <p class="itb-error-message mb-0" v-if="!$v.phone.minLength"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.phone_must_have_minimum"
                                                    ]
                                                }}
                                                {{
                                                    $v.phone.$params.minLength
                                                        .min
                                                }}
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.digits"
                                                    ]
                                                }}
                                            </p>
                                            <p class="itb-error-message mb-0" v-if="!$v.phone.phoneSymbols"
                                                aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.phone_must_be_numeric"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- delivery column -->
                                    <div class="col delivery-col">
                                        <div class="row">
                                            <div class="col-lg-7">
                                                <h3 id="itb-cart-delivery-info">
                                                    {{
                                                        appParams
                                                            .staticTranslations[
                                                        "carts.delivery_address"
                                                        ]
                                                    }}
                                                </h3>
                                            </div>
                                            <div id="itb-cart-same-as-billing-wrapper"
                                                class="col-lg-5 text-right itb-inline-checkbox-wrapper"
                                                v-if="chosenAddress === null" :class="same_as_billing
                                                    ? 'itb-active'
                                                    : ''
                                                    ">
                                                <label for="itb-cart-same-as-billing"
                                                    class="itb-inline-checkbox-label ml-auto">
                                                    <input type="checkbox" id="itb-cart-same-as-billing"
                                                        @input="sameAsBilling" v-model.trim="same_as_billing
                                                            " />
                                                    <span class="itb-checkmark"></span>
                                                    {{
                                                        appParams
                                                            .staticTranslations[
                                                        "carts.same_as_billing"
                                                        ]
                                                    }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="itb-carts-saved-addresses">
                                            <label class="itb-cart-mt">{{
                                                appParams.staticTranslations[
                                                "carts.saved_addresses"
                                                ]
                                            }}</label>
                                            <div>
                                                <button v-if="addresses.length > 0" type="button"
                                                    class="btn btn-light mr-1" v-for="(
                                                        address, index
                                                    ) in addresses" :key="address.id" @click="
                                                        changeAddress(index)
                                                        " :class="[
                                                            chosenAddress == index
                                                                ? 'itb-chosen-address'
                                                                : '',
                                                        ]">
                                                    {{ index + 1 }}
                                                </button>
                                                <button type="button" class="btn btn-light mr-1" :class="{
                                                    'itb-chosen-address': chosenAddress === null,
                                                    'itb-long-new-address-btn': typeof appParams.staticTranslations['carts.new'] === 'string' && appParams.staticTranslations['carts.new'].length > 3
                                                }" @click="addNewAddress">
                                                    <span>
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                            "carts.new"
                                                            ]
                                                        }}
                                                    </span>
                                                    <p v-if="typeof appParams.staticTranslations['carts.new'] === 'string' && appParams.staticTranslations['carts.new'].length > 3"
                                                        class="tooltiptext mb-0">
                                                        {{ appParams
                                                            .staticTranslations[
                                                            "carts.new"
                                                        ] }}
                                                    </p>
                                                </button>
                                            </div>
                                        </div>
                                        <label for="itb-cart-form-delivery-name" class="itb-cart-mt">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_name"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-delivery-name"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.delivery_name_placeholder'
                                            ]
                                                " v-model.trim="delivery_name" ref="delivery_name" />

                                        <label for="itb-cart-form-delivery-company" class="itb-cart-mt">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_company"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-delivery-company"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.delivery_company_placeholder'
                                            ]
                                                " v-model.trim="delivery_company" ref="delivery_company" />

                                        <label for="itb-cart-form-delivery-street" class="itb-cart-mt">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_street"
                                            ]
                                        }}</label>
                                        <input type="text" class="form-control" id="itb-cart-form-delivery-street"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.delivery_street_placeholder'
                                            ]
                                                " v-model.trim="delivery_street" ref="delivery_street" />

                                        <div class="row itb-city-postcode">
                                            <div class="col-lg-8">
                                                <label for="itb-cart-form-delivery-city" class="itb-cart-mt" :class="{
                                                    'itb-label-error':
                                                        $v.delivery_city
                                                            .$error,
                                                }">{{
                                                    appParams
                                                        .staticTranslations[
                                                    "clients.delivery_city"
                                                    ]
                                                }}</label>
                                                <input type="text" class="form-control" id="itb-cart-form-delivery-city"
                                                    :placeholder="appParams
                                                        .staticTranslations[
                                                        'clients.delivery_city_placeholder'
                                                    ]
                                                        " v-model.trim="delivery_city" @input="
                                                            $v.delivery_city.$touch()
                                                            " :class="{
                                                                'itb-field-error':
                                                                    $v.delivery_city
                                                                        .$error,
                                                            }" ref="delivery_city" />
                                                <div v-if="
                                                    $v.delivery_city.$dirty
                                                ">
                                                    <p class="itb-error-message mb-0" v-if="
                                                        !$v.delivery_city
                                                            .required
                                                    " aria-live="assertive">
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                            "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <label for="itb-cart-form-delivery-postcode" class="itb-cart-mt" :class="{
                                                    'itb-label-error':
                                                        $v.delivery_postcode
                                                            .$error,
                                                }">{{
                                                    appParams
                                                        .staticTranslations[
                                                    "clients.delivery_postcode"
                                                    ]
                                                }}</label>
                                                <input type="text" class="form-control"
                                                    id="itb-cart-form-delivery-postcode" :placeholder="appParams
                                                        .staticTranslations[
                                                        'clients.delivery_postcode_placeholder'
                                                    ]
                                                        " v-model.trim="delivery_postcode
                                                            " @input="
                                                                $v.delivery_postcode.$touch()
                                                                " :class="{
                                                                    'itb-field-error':
                                                                        $v.delivery_postcode
                                                                            .$error,
                                                                }" ref="delivery_postcode" />
                                                <div v-if="
                                                    $v.delivery_postcode
                                                        .$dirty
                                                ">
                                                    <p class="itb-error-message mb-0" v-if="
                                                        !$v
                                                            .delivery_postcode
                                                            .required
                                                    " aria-live="assertive">
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                            "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <label for="itb-cart-form-delivery-country" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.delivery_country.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_country"
                                            ]
                                        }}</label>
                                        <typeahead-autocomplete v-if="isCountryListLoaded" v-model="delivery_country"
                                            :items="countryList" :initialText="deliveryInitialCountry.text
                                                " :initialValue="deliveryInitialCountry.value
                                                    " class="itb-autocomplete" id="itb-cart-form-bill-country" @change="
                                                        $v.delivery_country.$touch()
                                                        " :class="{
                                                            'itb-field-error':
                                                                $v.delivery_country.$error,
                                                        }" ref="delivery_country" :key="deliveryAutocompleteRefreshCounter
                                                            " />
                                        <div v-if="$v.delivery_country.$dirty">
                                            <p class="itb-error-message mb-0" v-if="
                                                !$v.delivery_country
                                                    .required
                                            " aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label for="itb-cart-form-delivery_phone" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.delivery_phone.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_phone"
                                            ]
                                        }}</label>
                                        <input type="tel" class="form-control" id="itb-cart-form-delivery_phone"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.delivery_phone_placeholder'
                                            ]
                                                " v-model.trim="delivery_phone" @input="$v.delivery_phone.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.delivery_phone.$error,
                                            }" ref="delivery_phone" />
                                        <div v-if="$v.delivery_phone.$dirty">
                                            <p class="itb-error-message mb-0" v-if="
                                                !$v.delivery_phone.minLength
                                            " aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.phone_must_have_minimum"
                                                    ]
                                                }}
                                                {{
                                                    $v.delivery_phone.$params
                                                        .minLength.min
                                                }}
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.digits"
                                                    ]
                                                }}
                                            </p>
                                            <p class="itb-error-message mb-0" v-if="
                                                !$v.delivery_phone
                                                    .phoneSymbols
                                            " aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.phone_must_be_numeric"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col itb-note-wrapper">
                                        <label for="itb-cart-form-delivery-note" class="itb-cart-mt" :class="{
                                            'itb-label-error':
                                                $v.delivery_note.$error,
                                        }">{{
                                            appParams.staticTranslations[
                                            "clients.delivery_note"
                                            ]
                                        }}</label>
                                        <textarea class="form-control" id="itb-cart-form-delivery-note" rows="5"
                                            :placeholder="appParams.staticTranslations[
                                                'clients.delivery_note_placeholder'
                                            ]
                                                " v-model.trim="delivery_note" @input="$v.delivery_note.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.delivery_note.$error,
                                            }" ref="delivery_note" />
                                        <div v-if="$v.delivery_note.$dirty">
                                            <p class="itb-error-message mb-0" v-if="
                                                !$v.delivery_note.maxLength
                                            " aria-live="assertive">
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "carts.field_must_not_exceed_500_characters"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row ml-0">
                                    <div class="col-12 pl-0 mt-3 itb-contact-attachment d-flex align-items-center mb-0">
                                        <p class="mb-0" :class="{
                                            'itb-label-error':
                                                exceedSizeLimit,
                                        }">
                                            {{
                                                appParams.staticTranslations[
                                                "general.want_attach_file_cart"
                                                ]
                                            }}
                                        </p>
                                        <button type="button" class="ml-2 mb-0" :class="{
                                            'itb-attach-disabled':
                                                submitStatus,
                                            'itb-attach-enabled':
                                                !submitStatus,
                                        }" :disabled="submitStatus" @click.stop="
                                            $refs.attachFileInput.click()
                                            ">
                                            <span class="mdi mdi-paperclip"></span>
                                            <span>
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                    "general.choose_file"
                                                    ]
                                                }}
                                            </span>
                                        </button>

                                        <input type="file" ref="attachFileInput" style="display: none"
                                            @change="attachFile($event)" />
                                    </div>
                                    <div v-if="isFileLoaded" class="col-12 pl-0 d-flex align-items-center">
                                        <p class="mb-0">
                                            {{ displayedFileName }}
                                        </p>
                                        <img src="/images/cancel.png" alt="delete"
                                            class="itb-delete-cart-item ml-2 mb-0" style="width: 27px"
                                            v-if="!submitStatus" @click="discardAttachment" />
                                    </div>
                                    <div v-if="exceedSizeLimit" class="pl-0 d-flex align-items-center">
                                        <p class="itb-error-message mb-0 mt-0" aria-live="assertive">
                                            {{
                                                appParams.staticTranslations[
                                                "general.file_should_be_smaller"
                                                ]
                                            }}
                                        </p>
                                        <img src="/images/cancel.png" alt="delete"
                                            class="itb-delete-cart-item ml-2 mb-0" style="width: 27px"
                                            v-if="!submitStatus" @click="discardAttachment" />
                                    </div>
                                </div>
                                <div id="itb-agree-terms-wrapper" class="text-center itb-inline-checkbox-wrapper"
                                    :class="agree_terms ? 'itb-active' : ''">
                                    <label for="itb-cart-agree-terms" class="itb-inline-checkbox-label" :class="{
                                        'itb-label-error':
                                            $v.agree_terms.$error,
                                    }">
                                        <input type="checkbox" id="itb-cart-agree-terms" v-model.trim="agree_terms"
                                            @input="$v.agree_terms.$touch()" :class="{
                                                'itb-field-error':
                                                    $v.agree_terms.$error,
                                            }" ref="agree_terms" />
                                        <span class="itb-checkmark"></span>
                                        {{
                                            appParams.staticTranslations[
                                            "carts.agree_terms"
                                            ]
                                        }}
                                        <a href="javascript:void(0)" @click="showTerms">
                                            {{
                                                appParams.staticTranslations[
                                                "carts.terms"
                                                ]
                                            }}
                                        </a>
                                    </label>

                                    <div v-if="$v.agree_terms.$dirty">
                                        <p class="itb-error-message mb-0" v-if="!$v.agree_terms.sameAs"
                                            aria-live="assertive">
                                            {{
                                                appParams.staticTranslations[
                                                "carts.must_agree_terms"
                                                ]
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="itb-submit-btn-wrapper">
                                    <button type="submit" class="btn btn-primary itb-add-to-basket" :disabled="submitStatus || !isDiscountApplied
                                        " style="margin-bottom: 60px">
                                        {{
                                            appParams.staticTranslations[
                                            "carts.copy_to_basket"
                                            ]
                                        }}&nbsp;
                                        <img src="/images/icons/4soft_icon_paperplane.svg"
                                            alt="Tlačítko pro odeslání zprávy" class="itb-icon itb-paperplane" />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="container">
            <div class="row" v-if="!message">
                <div
                    class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center">
                    <div v-if="isOrderPlaced" class="alert itb-alert alert-success" role="alert">
                        {{
                            appParams.staticTranslations[
                            "carts.form_sent_succesfully"
                            ]
                        }}
                    </div>
                    <div v-else class="alert itb-alert alert-info" role="alert">
                        {{
                            appParams.staticTranslations["carts.no_active_cart"]
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    required,
    email,
    maxLength,
    numeric,
    minLength,
    sameAs,
    helpers,
} from "vuelidate/lib/validators";
const phoneSymbols = helpers.regex(
    "phoneSymbols",
    /^([+]?[\s]?[0-9]+)?([\s]?[0-9])+$/
);

import TermsAndCondition from "../components/TermsAndCondition";
import DeleteDialog from "../components/DeleteDialog";
import DeleteNoteDialog from "../components/DeleteNoteDialog";
import DeleteCartDialog from "../components/DeleteCartDialog";
import TypeaheadAutocomplete from "typeahead-autocomplete";

export default {
    data() {
        return {
            pageParams: [],
            graphics: [],
            cartId: "",
            showGraphicList: false,
            discountPercentage: 0,
            discountValue: 0,
            totalWeight: 0,
            totalPrice: 0,
            totalPriceRaw: 0,
            totalPriceWithDiscount: 0,
            totalPriceWithDiscountFormatted: 0,
            bonusDiscount: 2.5,
            bonusDiscountAmount: 0,
            bonusDiscountAmountFormatted: "",
            bonusDiscountCode: "eshop",
            inAdvanceDiscount: 0,
            inAdvanceDiscountAmount: 0,
            inAdvanceDiscountAmountFormatted: "",
            inAdvanceDiscountCode: "ADD",
            wantToPayInAdvance: false,
            totalOriginalPrice: 0,
            totalOriginalPriceFormatted: "",
            totalQuantity: 0,
            bill_name: null,
            bill_company: null,
            bill_street: null,
            bill_city: null,
            bill_postcode: null,
            bill_country: null,
            bill_country_text: "",
            email: null,
            phone: null,
            vat: null,
            delivery_note: null,
            delivery_phone: null,
            delivery_name: null,
            delivery_company: null,
            delivery_street: null,
            delivery_city: null,
            delivery_postcode: null,
            delivery_country: null,
            same_as_billing: false,
            submitStatus: false,
            agree_terms: false,
            message: null,
            updatedProfile: {},
            messageDialog: false,
            deleteConfirmation: false,
            selectedProduct: null,
            isSaveDisabled: false,
            addresses: [],
            chosenAddress: 0,
            isProductNoteEdited: [],
            isProductNoteValid: [],
            isProductNoteOpened: [],
            previousProductNotes: [],
            deleteNoteConfirmation: false,
            selectedNoteProduct: null,
            deleteCartConfirmation: false,
            exceedSizeLimit: false,
            isFileLoaded: false,
            displayedFileName: "",
            file: null,
            selectedCountry: "",
            countryList: [],
            deliveryInitialCountry: {
                text: "",
                value: "",
            },
            isCountryListLoaded: false,
            currentLanguage: "",
            isDiscountApplied: false,
            deliveryAutocompleteRefreshCounter: 0,
            isOrderPlaced: false,
            pohodaPriceName: "",
        };
    },

    created() {
        // when cart is accessed without being logged in, it will redirect to home
        this.logRedirect();
        this.getLastCart();

        this.getCurrentLanguage();
        // executes refreshClientData in callback
        // refreshClientData executes getCountryList, so that the countries can be assigned to autocomplete component

        this.getCountryList();
    },

    mounted() {
        axios
            .get("/getCartPage")
            .then((response) => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    components: {
        TermsAndCondition,
        DeleteDialog,
        DeleteNoteDialog,
        DeleteCartDialog,
    },
    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),

        sameAsBillingCountryName() {
            let index = this.countryList.findIndex(
                (country) => country.value == this.bill_country
            );
            let countryName = "";
            if (index > -1) {
                countryName = this.countryList[index].text;
            }

            return countryName;
        },
    },
    validations: {
        bill_name: {
            required,
        },
        bill_company: {
            required,
        },
        bill_street: {
            required,
        },
        bill_city: {
            required,
        },
        bill_postcode: {
            required,
        },
        bill_country: {
            required,
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(7),
            phoneSymbols,
        },
        delivery_note: {
            maxLength: maxLength(2000),
        },
        delivery_phone: {
            minLength: minLength(7),
            phoneSymbols,
        },
        delivery_city: {
            required,
        },
        delivery_country: {
            required,
        },
        delivery_postcode: {
            required,
        },
        agree_terms: {
            required,
            sameAs: sameAs(() => true),
        },
    },
    methods: {
        ...mapActions(["setPageParams", "setFormParams", "updateCartCounter"]),
        logRedirect() {
            if (!this.isLoggedIn) {
                if (this.$route.path != "/") {
                    this.$router.push("/");
                }
            }
        },
        async getLastCart() {
            await axios
                .post("/getLastCart", this.profile)
                .then((response) => {
                    this.graphics = response.data;
                    if (response.data.length > 0) {
                        this.cartId = response.data[0].cart_id;
                        this.showGraphicList = true;
                        this.getDiscount();
                        this.calculateTotals();
                        this.isProductNoteEdited = Array(
                            this.graphics.length
                        ).fill(false);
                        this.isProductNoteValid = Array(
                            this.graphics.length
                        ).fill(true);
                        this.isProductNoteOpened = Array(
                            this.graphics.length
                        ).fill(false);
                        this.previousProductNotes = Array(
                            this.graphics.length
                        ).fill("");
                    } else {
                        this.showGraphicList = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getDiscount() {
            axios
                .post("/getDiscount", { client_id: this.profile.id })
                .then((response) => {
                    this.pohodaPriceName = response.data.pohodaPriceName;
                    this.discountValue = response.data.discount;

                    if (this.pohodaPriceName) {
                        // this.discountValue = 0;
                        this.bonusDiscount = 0;
                    }

                    if (this.discountValue > 0) {
                        this.discountPercentage = this.discountValue / 100;
                    } else {
                        this.discountPercentage = 0;
                    }
                    this.correctPrice();
                    this.isDiscountApplied = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        correctPriceWithAdvanceDiscount() {
            this.wantToPayInAdvance = !this.wantToPayInAdvance;
            this.inAdvanceDiscount = this.wantToPayInAdvance ? 2.5 : 0;
            this.resetTotalPrices();
            this.reassignPrice();
            this.correctPrice();
        },

        correctPrice() {
            this.graphics.forEach((item) => {
                if (this.discountPercentage > 0) {
                    item.discounted = true;
                } else {
                    item.discounted = false;
                }

                item.unformattedPrice = item.price;
                item.unitPrice = !!this.constantUnitPrice(item)
                    ? this.constantUnitPrice(item)
                    : item.price;

                item.discountedUnitPrice = !!this.constantUnitPrice(item)
                    ? this.constantUnitPrice(item)
                    : parseFloat(
                        parseFloat(
                            item.price * (1 - this.discountPercentage)
                        ).toFixed(2)
                    );

                //formatted prices to be used in email
                item.unitPriceFormatted = new Intl.NumberFormat("en-EN", {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(item.unitPrice);

                item.discountedUnitPriceFormatted = new Intl.NumberFormat(
                    "en-EN",
                    {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }
                ).format(item.discountedUnitPrice);

                // price without discount
                item.originalPrice = !!this.constantUnitPrice(item)
                    ? this.constantUnitPrice(item) * item.quantity
                    : item.price * item.quantity;

                this.totalOriginalPrice =
                    this.totalOriginalPrice + item.originalPrice;

                //price to display and also used in email

                item.price = !!this.constantUnitPrice(item)
                    ? this.constantUnitPrice(item)
                    : parseFloat(
                        parseFloat(
                            item.price * (1 - this.discountPercentage)
                        ).toFixed(2)
                    );
                item.price = item.price * item.quantity;
                item.graphicPrice = item.price;
                this.totalPrice = this.totalPrice + item.price;
                item.price = new Intl.NumberFormat("en-EN", {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(item.price);
            });

            this.totalPriceRaw = this.totalPrice;

            this.bonusDiscountAmount = parseFloat(
                -(this.bonusDiscount / 100) * this.totalPrice
            ).toFixed(2);
            this.bonusDiscountAmountFormatted = new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.bonusDiscountAmount);

            this.inAdvanceDiscountAmount = parseFloat(
                -(this.inAdvanceDiscount / 100) * this.totalPrice
            ).toFixed(2);
            this.inAdvanceDiscountAmountFormatted = new Intl.NumberFormat(
                "en-EN",
                {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }
            ).format(this.inAdvanceDiscountAmount);

            this.totalPriceWithDiscount =
                parseFloat(this.totalPrice) +
                parseFloat(this.bonusDiscountAmount) +
                parseFloat(this.inAdvanceDiscountAmount);

            this.totalPrice = new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.totalPrice);

            this.totalPriceWithDiscountFormatted = new Intl.NumberFormat(
                "en-EN",
                {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }
            ).format(this.totalPriceWithDiscount);

            this.totalOriginalPriceFormatted = new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.totalOriginalPrice);
        },

        constantUnitPrice(graphic) {
            let price = null;
            if (graphic.fix_price) {
                price = graphic.fix_price;
            }

            if (graphic.pohoda_client_price) {
                price = graphic.pohoda_client_price;
            }

            if (graphic.fix_price && graphic.pohoda_client_price) {
                price = graphic.pohoda_client_price;
            }

            return price;
        },

        calculateTotals() {
            this.graphics.forEach((item) => {
                this.totalQuantity =
                    parseInt(this.totalQuantity) + parseInt(item.quantity);
                if (String(item.weight).indexOf(",") < 0) {
                    item.formattedWeight = parseFloat(item.weight);
                    if (String(item.weight).indexOf(".") < 0) {
                        item.weight = item.weight + ",0";
                    } else {
                        item.weight = String(item.weight).replace(".", ",");
                    }
                } else {
                    item.formattedWeight = parseFloat(
                        item.weight.replace(/,/, ".")
                    );
                }
                this.totalWeight =
                    parseFloat(this.totalWeight) +
                    item.formattedWeight * parseInt(item.quantity);
            });
            this.totalWeight = new Intl.NumberFormat("en-EN", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            }).format(this.totalWeight);
        },
        sameAsBilling() {
            if (!this.same_as_billing) {
                this.delivery_phone = this.phone;
                this.delivery_name = this.bill_name;
                this.delivery_company = this.bill_company;
                this.delivery_street = this.bill_street;
                this.delivery_city = this.bill_city;

                this.deliveryInitialCountry.text =
                    this.sameAsBillingCountryName;
                this.deliveryInitialCountry.value = this.bill_country;
                this.delivery_country = this.bill_country;

                this.delivery_postcode = this.bill_postcode;
                this.chosenAddress = null;
                this.same_as_billing = true;
            } else {
                this.delivery_phone = "";
                this.delivery_name = "";
                this.delivery_company = "";
                this.delivery_street = "";
                this.delivery_city = "";

                this.deliveryInitialCountry.text = "";
                this.deliveryInitialCountry.value = "";
                this.delivery_country = "";

                this.delivery_postcode = "";

                this.same_as_billing = false;
            }
            ++this.deliveryAutocompleteRefreshCounter;
        },
        async save() {
            var toData = new FormData();

            if (this.file instanceof File) {
                if (!this.exceedSizeLimit) {
                    toData.append("file", this.file);
                }
            } else {
                toData.append("file", "none");
            }

            toData.append("fileLinkPrefix", window.location.origin);
            toData.append("bill_name", this.bill_name);
            toData.append("bill_company", this.bill_company);
            toData.append("bill_street", this.bill_street);
            toData.append("bill_city", this.bill_city);
            toData.append("bill_postcode", this.bill_postcode);
            toData.append("bill_country", this.bill_country);
            toData.append("email", this.email);
            toData.append("phone", this.phone);
            toData.append("vat", this.vat);
            toData.append("delivery_note", this.delivery_note);
            toData.append("delivery_phone", this.delivery_phone);
            toData.append("delivery_name", this.delivery_name);
            toData.append("delivery_company", this.delivery_company);
            toData.append("delivery_street", this.delivery_street);
            toData.append("delivery_city", this.delivery_city);
            toData.append("delivery_country", this.delivery_country);
            toData.append("delivery_postcode", this.delivery_postcode);
            toData.append("totalWeight", this.totalWeight);
            toData.append("totalPrice", this.totalPrice);
            toData.append("totalPriceRaw", this.totalPriceRaw);
            toData.append(
                "totalPriceWithDiscountFormatted",
                this.totalPriceWithDiscountFormatted
            );
            toData.append("totalQuantity", this.totalQuantity);
            toData.append("totalOriginalPrice", this.totalOriginalPrice);
            toData.append(
                "totalOriginalPriceFormatted",
                this.totalOriginalPriceFormatted
            );
            toData.append("client_id", this.profile.id);
            toData.append("graphics", JSON.stringify(this.graphics));
            toData.append("discount", this.profile.discount);
            toData.append("discountValue", this.discountValue);
            toData.append("bonusDiscount", this.bonusDiscount);
            toData.append("bonusDiscountAmount", this.bonusDiscountAmount);
            toData.append(
                "bonusDiscountAmountFormatted",
                this.bonusDiscountAmountFormatted
            );
            toData.append("inAdvanceDiscount", this.inAdvanceDiscount);
            toData.append(
                "inAdvanceDiscountAmount",
                this.inAdvanceDiscountAmount
            );
            toData.append(
                "inAdvanceDiscountAmountFormatted",
                this.inAdvanceDiscountAmountFormatted
            );
            toData.append(
                "totalDiscount",
                parseFloat(this.bonusDiscount) +
                parseFloat(this.discountValue) +
                parseFloat(this.inAdvanceDiscount)
            );
            toData.append("orderedByEmail", this.$store.state.profile.email);

            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = false;
                for (let key in Object.keys(this.$v)) {
                    const input = Object.keys(this.$v)[key];
                    if (input.includes("$")) return false;
                    if (this.$v[input].$error) {
                        this.$refs[input].scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                        break;
                    }
                }
            } else if (!this.exceedSizeLimit && this.isDiscountApplied) {
                this.submitStatus = true;
                await axios
                    .post("/placeOrder", toData)
                    .then((response) => {
                        this.isOrderPlaced = true;

                        this.$v.$reset();
                        this.$store.dispatch("resetCartCounter");
                        this.graphics = null;
                        this.showGraphicList = false;
                        this.same_as_billing = false;
                        this.agree_terms = false;
                        this.resetTotals();
                        this.chosenAddress = 0;
                        this.isFileLoaded = false;
                        this.exceedSizeLimit = false;
                        this.file = null;
                        this.refreshClientData();
                        this.scrollToTop();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.isFileLoaded = false;
                        this.exceedSizeLimit = false;
                        this.file = null;
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "carts.form_error"
                            ],
                            type: "danger",
                        };
                        setTimeout(() => {
                            this.message = null;
                        }, 3000);
                    });
                setTimeout(() => {
                    this.submitStatus = false;
                }, 500);
            }
        },

        getCurrentLanguage() {
            axios
                .get("/getCurrentLanguage")
                .then((response) => {
                    this.currentLanguage = response.data;
                    this.refreshClientData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        refreshClientData() {
            var id = {
                idNumber: this.profile.id,
                language: this.currentLanguage,
                isClientRepresentative: this.profile.isClientRepresentative,
                email: this.profile.email,
            };
            axios
                .post("/api/auth/refresh-client-info", id)
                .then((response) => {
                    this.updatedProfile = response.data;
                    this.addresses = this.updatedProfile.addresses;

                    this.bill_name = this.updatedProfile.name
                        ? String(this.updatedProfile.name)
                        : "";
                    this.bill_company = this.updatedProfile.bill_company
                        ? String(this.updatedProfile.bill_company)
                        : "";
                    this.bill_street = this.updatedProfile.bill_street
                        ? String(this.updatedProfile.bill_street)
                        : "";
                    this.bill_city = this.updatedProfile.bill_city
                        ? String(this.updatedProfile.bill_city)
                        : "";
                    this.bill_postcode = this.updatedProfile.bill_postcode
                        ? String(this.updatedProfile.bill_postcode)
                        : "";
                    this.bill_country = this.updatedProfile.bill_country
                        ? String(this.updatedProfile.bill_country)
                        : "";
                    this.bill_country_text = this.updatedProfile.initialCountry
                        .text
                        ? String(this.updatedProfile.initialCountry.text)
                        : "";
                    this.email = this.updatedProfile.email
                        ? String(this.updatedProfile.email)
                        : "";
                    this.phone = this.updatedProfile.phone
                        ? String(this.updatedProfile.phone)
                        : "";
                    this.vat = this.updatedProfile.vat
                        ? String(this.updatedProfile.vat)
                        : "";
                    this.delivery_note = "";

                    if (this.addresses.length > 0) {
                        this.changeAddress(0);
                    } else {
                        this.delivery_phone = "";
                        this.delivery_name = "";
                        this.delivery_company = "";
                        this.delivery_street = "";
                        this.delivery_city = "";
                        this.delivery_country = "";
                        this.delivery_postcode = "";
                        this.chosenAddress = null;
                    }
                    this.getCountryList();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        showTerms() {
            this.messageDialog = !this.messageDialog;
        },
        confirmDeletion(index) {
            this.deleteConfirmation = true;
            this.selectedProduct = index;
        },
        async deleteGraphic() {
            this.deleteConfirmation = false;
            let index = this.selectedProduct;
            var graphicData = {
                cart_id: this.cartId,
                graphic_code: this.graphics[index].graphic_code,
            };
            this.graphics.splice(index, 1);
            this.isProductNoteEdited.splice(index, 1);
            this.isProductNoteValid.splice(index, 1);
            this.isProductNoteOpened.splice(index, 1);
            this.checkCartEmpty();
            await axios
                .post("/deleteGraphic", graphicData)
                .then((response) => {
                    this.resetTotals();
                    this.reassignPrice();
                    this.correctPrice();
                    this.calculateTotals();
                    this.$store.dispatch("resetCartCounter");
                    this.updateCartCounter(this.totalQuantity);
                    this.selectedProduct = null;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        cancelDeletion() {
            this.deleteConfirmation = false;
            this.selectedProduct = null;
        },
        increaseQuantity(index) {
            this.graphics[index].quantity = this.graphics[index].quantity + 1;
            this.resetTotals();
            this.reassignPrice();
            this.correctPrice();
            this.calculateTotals();
            this.$store.dispatch("resetCartCounter");
            this.updateCartCounter(this.totalQuantity);
            this.updateQuantity(index);
        },
        decreaseQuantity(index) {
            if (this.graphics[index].quantity > 1) {
                this.graphics[index].quantity =
                    this.graphics[index].quantity - 1;
                this.resetTotals();
                this.reassignPrice();
                this.correctPrice();
                this.calculateTotals();
                this.$store.dispatch("resetCartCounter");
                this.updateCartCounter(this.totalQuantity);
                this.updateQuantity(index);
            } else {
                this.graphics[index].quantity = 1;
            }
        },
        changeQuantity(index) {
            if (!this.graphics[index].quantity == "") {
                this.graphics[index].quantity = parseInt(
                    this.graphics[index].quantity,
                    10
                );
                this.resetTotals();
                this.reassignPrice();
                this.correctPrice();
                this.calculateTotals();
                this.$store.dispatch("resetCartCounter");
                this.updateCartCounter(this.totalQuantity);
                this.updateQuantity(index);
            } else {
                this.graphics[index].quantity = 1;
                this.resetTotals();
                this.reassignPrice();
                this.correctPrice();
                this.calculateTotals();
                this.$store.dispatch("resetCartCounter");
                this.updateCartCounter(this.totalQuantity);
                this.updateQuantity(index);
            }
        },
        updateQuantity(index) {
            var quantityData = {
                cart_id: this.cartId,
                graphic_code: this.graphics[index].graphic_code,
                quantity: this.graphics[index].quantity,
            };
            axios
                .post("/updateQuantity", quantityData)
                .then((response) => { })
                .catch((error) => {
                    console.log(error);
                });
        },

        resetTotals() {
            this.totalQuantity = 0;
            this.totalWeight = 0;
            this.resetTotalPrices();
        },

        resetTotalPrices() {
            this.totalPrice = 0;
            this.totalPriceRaw = 0;
            this.totalPriceWithDiscount = 0;
            this.totalPriceWithDiscountFormatted = 0;
            this.totalOriginalPrice = 0;
        },

        reassignPrice() {
            this.graphics.forEach((item) => {
                item.price = item.unformattedPrice;
            });
        },

        saveCart() {
            axios
                .post("/saveCart", {
                    cart_id: this.cartId,
                    orderedByEmail: this.$store.state.profile.email,
                })
                .then((response) => {
                    this.message = {
                        text:
                            this.appParams.staticTranslations[
                            "carts.cart_saved_successfully"
                            ] +
                            ". " +
                            this.appParams.staticTranslations[
                            "carts.cart_saved_as"
                            ] +
                            " " +
                            this.appParams.staticTranslations["carts.cart"] +
                            " " +
                            String(response.data),
                        type: "success",
                    };
                    this.isSaveDisabled = true;
                    setTimeout(() => {
                        this.message = null;
                        this.isSaveDisabled = false;
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    this.message = {
                        text: this.appParams.staticTranslations[
                            "carts.form_error"
                        ],
                        type: "danger",
                    };
                    setTimeout(() => {
                        this.message = null;
                    }, 3000);
                });
        },

        checkCartEmpty() {
            if (this.graphics.length < 1) {
                this.showGraphicList = false;
                axios
                    .post("/disableCart", { cart_id: this.cartId })
                    .then((response) => { })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        changeAddress(index) {
            this.chosenAddress = index;
            this.same_as_billing = false;

            this.delivery_phone = this.addresses[this.chosenAddress].phone
                ? this.addresses[this.chosenAddress].phone
                : "";
            this.delivery_phone = String(this.delivery_phone);

            this.delivery_name = this.addresses[this.chosenAddress].name
                ? this.addresses[this.chosenAddress].name
                : "";
            this.delivery_name = String(this.delivery_name);

            this.delivery_company = this.addresses[this.chosenAddress].company
                ? this.addresses[this.chosenAddress].company
                : "";
            this.delivery_company = String(this.delivery_company);

            this.delivery_street = this.addresses[this.chosenAddress].street
                ? this.addresses[this.chosenAddress].street
                : "";
            this.delivery_street = String(this.delivery_street);

            this.delivery_city = this.addresses[this.chosenAddress].city
                ? this.addresses[this.chosenAddress].city
                : "";
            this.delivery_city = String(this.delivery_city);

            this.deliveryInitialCountry.text =
                this.addresses[this.chosenAddress].initialCountry.text;
            this.deliveryInitialCountry.value =
                this.addresses[this.chosenAddress].initialCountry.value;
            this.delivery_country = this.addresses[this.chosenAddress].country
                ? this.addresses[this.chosenAddress].country
                : "";
            this.delivery_country = String(this.delivery_country);

            this.delivery_postcode = this.addresses[this.chosenAddress].postcode
                ? this.addresses[this.chosenAddress].postcode
                : "";
            this.delivery_postcode = String(this.delivery_postcode);

            ++this.deliveryAutocompleteRefreshCounter;
        },

        addNewAddress() {
            this.chosenAddress = null;
            this.same_as_billing = false;
            this.delivery_phone = "";
            this.delivery_name = "";
            this.delivery_company = "";
            this.delivery_street = "";
            this.delivery_city = "";

            this.deliveryInitialCountry.text = "";
            this.deliveryInitialCountry.value = "";
            this.delivery_country = "";

            this.delivery_postcode = "";

            ++this.deliveryAutocompleteRefreshCounter;
        },
        verifyProductNote(index) {
            this.isProductNoteValid[index] =
                this.graphics[index].note.length > 255 ? false : true;

            //make array change reactive
            Vue.set(
                this.isProductNoteValid,
                index,
                this.isProductNoteValid[index]
            );
        },

        editProductNote(index) {
            this.isProductNoteOpened[index] = true;
            Vue.set(
                this.isProductNoteOpened,
                index,
                this.isProductNoteOpened[index]
            );
            this.previousProductNotes[index] = this.graphics[index].note;
        },

        saveProductNote(index) {
            this.isProductNoteOpened[index] = false;
            Vue.set(
                this.isProductNoteOpened,
                index,
                this.isProductNoteOpened[index]
            );
            this.isProductNoteEdited[index] = true;
            Vue.set(
                this.isProductNoteOpened,
                index,
                this.isProductNoteOpened[index]
            );

            this.updateProductNote(index);
        },
        closeProductNote(index) {
            this.graphics[index].note = this.previousProductNotes[index];
            this.isProductNoteOpened[index] = false;
            Vue.set(
                this.isProductNoteOpened,
                index,
                this.isProductNoteOpened[index]
            );
        },
        deleteProductNote() {
            this.deleteNoteConfirmation = false;
            let index = this.selectedNoteProduct;
            this.graphics[index].note = "";
            this.updateProductNote(index);
        },
        updateProductNote(index) {
            this.selectedNoteProduct = null;
            var noteData = {
                cart_id: this.cartId,
                graphic_code: this.graphics[index].graphic_code,
                note: this.graphics[index].note,
            };
            axios
                .post("/updateProductNote", noteData)
                .then((response) => { })
                .catch((error) => {
                    console.log(error);
                });
        },

        confirmNoteDeletion(index) {
            this.deleteNoteConfirmation = true;
            this.selectedNoteProduct = index;
        },

        cancelNoteDeletion() {
            this.deleteNoteConfirmation = false;
            this.selectedNoteProduct = null;
        },

        confirmCartDeletion() {
            this.deleteCartConfirmation = true;
        },
        async deleteCart() {
            this.deleteCartConfirmation = false;
            this.showGraphicList = false;
            await axios
                .post("/disableCart", { cart_id: this.cartId })
                .then((response) => {
                    this.$store.dispatch("resetCartCounter");
                    this.updateCartCounter(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        cancelCartDeletion() {
            this.deleteCartConfirmation = false;
        },
        attachFile(event) {
            this.file = event.target.files[0];

            this.displayedFileName = this.file.name.trim();
            // size limit  10000000 bytes
            if (this.file.size > 10000000) {
                this.exceedSizeLimit = true;
                this.isFileLoaded = false;
            } else {
                if (this.displayedFileName.length > 40) {
                    this.displayedFileName =
                        this.displayedFileName.slice(0, 33) +
                        " ... " +
                        this.displayedFileName.substr(-7, 7);
                }
                this.exceedSizeLimit = false;
                this.isFileLoaded = true;
            }
        },
        discardAttachment() {
            this.isFileLoaded = false;
            this.exceedSizeLimit = false;
            this.file = null;
        },

        getCountryList() {
            axios
                .get("/frontend-country-list")
                .then((response) => {
                    this.countryList = response.data.countries;

                    this.isCountryListLoaded = true;

                    if (response.data.errors.list) {
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "general.country_list_not_available"
                            ],
                            type: "danger",
                        };
                    }

                    if (response.data.errors.country) {
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "general.country_not_found"
                            ],
                            type: "danger",
                        };
                    }

                    if (
                        response.data.errors.list ||
                        response.data.errors.country
                    ) {
                        setTimeout(() => {
                            this.message = null;
                        }, 3000);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
